import {
  Box,
  Button,
  Flex,
  Heading,
  Spacer,
  Spinner,
  Text,
} from "@chakra-ui/react";
import React from "react";
import {IoDocumentTextOutline} from "react-icons/io5";
import {useQuery} from "react-query";
import {useNavigate} from "react-router-dom";

import {getAutomatedTestExists} from "../Api";
import {useFont} from "../hooks/FontProvider";
import {useTheme} from "../hooks/ThemeProvider";
import {Paths, SkillType} from "../model/Constants";
import {publicKeys} from "../QueryKeys";
import {extractData} from "../Utils";

type TestCardProps = {
  name: string;
  description: string;
  autoStart?: boolean;
  compact?: boolean;
  isDemo?: boolean;
  disabled?: boolean;
  skillType: SkillType;
};

const AutomatedTestCard = (props: TestCardProps) => {
  const theme = useTheme().theme;
  const font = useFont().font;
  const isDemo = props.isDemo || false;

  const testQuery = useQuery(publicKeys.testByTypeExists(props.skillType), () =>
  { return getAutomatedTestExists(props.skillType, isDemo).then(extractData); });

  const navigate = useNavigate();
  function goToAutomatedTest() {
      navigate(Paths.AUTOMATED_TEST.replace(
          ":skillType",
          props.skillType
      ));
  }

  if (props.autoStart)
    goToAutomatedTest();
  if (testQuery.isFetching) {
    return (
        <Spinner />
      );
  } else if (testQuery.data===null || testQuery.data !==true){
    return (<></>);
  } else if (props.compact) {
    return (
      <Button
        aria-label="Next"
        onClick={() => goToAutomatedTest()}
        colorScheme={theme.COLOR_SCHEME}
          width={font.iconButtonWidth}
          height={font.iconButtonHeight}
        disabled={props.disabled || (testQuery.data===null || testQuery.data !== true)}
        _disabled={{
          cursor: 'default',
          opacity: '0.4',
        }}
        fontWeight={font.weight}
        fontSize={font.buttonText}
        whiteSpace='break-spaces'
      >{props.name}</Button>
    );
  } else
    return (
      <Flex
          marginTop="2"
          marginBottom="2"
          borderWidth="1px"
          borderRadius="lg"
          borderColor="gray.300"
          borderStyle="solid"
          align="center"
          width="2xs"
          padding={5}
          bgColor={theme.BG}
          _dark={{ bgColor: "gray.800" }}
      >
        <Box>
          <IoDocumentTextOutline color={theme.SPECIAL_ACCENT} fontSize={36}/>
          <Button variant='link' color={theme.TEXT_ACCENT}
                  _dark={{ color: "white" }}
                  onClick={() => goToAutomatedTest()}
                  disabled={props.disabled || (testQuery.data===null || testQuery.data !==true)}
                  _disabled={{
                    cursor: 'default',
                    opacity: '0.4',
                  }}
          >
            <Heading as="h3" size={font.midHeading} paddingY={4}>
              {props.name}
            </Heading>
          </Button>
          <Text fontSize={font.p}>
            {props.description}
          </Text>
        </Box>
        <Spacer/>
        <Box>
        </Box>
      </Flex>
  );
};

export default AutomatedTestCard;
